import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HR_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#HR_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HR_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HR_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#E31D1C", d: "M10.076 6.397h11.4v4h-11.4z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.651 8.96H20.78c.017.769.022 2.11.022 3.402a616.998 616.998 0 01-.007 2.944l-.001.197v.029l-.001.003a4.918 4.918 0 01-.147.591 5.46 5.46 0 01-.692 1.433c-.694 1.014-1.955 2.056-4.305 2.056-2.347 0-3.547-1.04-4.186-2.045a5.166 5.166 0 01-.74-2.035v-.045l-.003-.196-.008-.709a3326.754 3326.754 0 01-.06-5.625zm.07 6.559s0 0 0 0h0z",
      fill: "#F7FCFF",
      stroke: "#E31D1C",
      strokeWidth: 1.125
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HR_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 10,
      y: 8,
      width: 12,
      height: 13
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.651 8.96H20.78c.017.769.022 2.11.022 3.402a616.998 616.998 0 01-.007 2.944l-.001.197v.029l-.001.003a4.918 4.918 0 01-.147.591 5.46 5.46 0 01-.692 1.433c-.694 1.014-1.955 2.056-4.305 2.056-2.347 0-3.547-1.04-4.186-2.045a5.166 5.166 0 01-.74-2.035v-.045l-.003-.196-.008-.709a3326.754 3326.754 0 01-.06-5.625zm.07 6.559s0 0 0 0h0z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 1.125
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HR_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.498 9.04h2.11v2.142h2.109V9.04h2.11v2.142h2.108V9.04h2.11v2.142h-2.11v2.141h-2.109v-2.141h-2.11v2.141h-2.109v-2.141h-2.109V9.04zm4.219 6.426h-2.11v-2.142h-2.109v2.142h2.11v2.142h-2.11v2.142h2.11v-2.142h2.109v2.142h2.11v-2.142h2.108v2.142h2.11v-2.142h-2.11v-2.142h2.11v-2.142h-2.11v2.142h-2.109v-2.142h-2.11v2.142zm2.11 2.142v-2.142h-2.11v2.142h2.11z",
      fill: "#F50100"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.453 8.163s.652-.348 1.209-.528c.556-.18.996-.278.996-.278l-.828-3.052-1.658-.62-.94 1.549 1.22 2.929z",
      fill: "#56C6F5",
      stroke: "#fff",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.182 6.49l.19-.091c.197.42.456.55.812.418.363-.135.511-.392.459-.798l.21-.028c.064.505-.14.857-.596 1.027-.465.173-.834-.012-1.075-.527z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.632 5.542l-.182.11a.054.054 0 01-.082-.057l.042-.209-.187-.102a.054.054 0 01.009-.099l.201-.069-.004-.213a.054.054 0 01.09-.042l.16.14.182-.11c.04-.024.09.011.082.057l-.042.21.187.102a.054.054 0 01-.009.099l-.202.068.005.213a.054.054 0 01-.09.042l-.16-.14z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.54 7.076s.557-.05 1.142-.038c.585.01 1.08.015 1.08.015l.285-3.01-1.253-1.13-1.392 1.157.139 3.006z",
      fill: "#56C6F5",
      stroke: "#fff",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.752 6.585c.482 0 .528-.521.528-.876-.123-.197-.098-.338-.494-.338-.395 0-.44.12-.556.338 0 .355.04.876.522.876zM16.293 5.113c.482 0 .528-.521.528-.876-.123-.197-.098-.338-.494-.338-.395 0-.44.12-.556.338 0 .355.04.876.522.876zM15.238 5.113c.482 0 .528-.521.528-.876-.123-.197-.098-.338-.493-.338-.396 0-.44.12-.556.338 0 .355.039.876.52.876z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.445 7.604l-.072-.244-.867-2.944-.04-.14.1-.104 1.239-1.284.149-.155.175.125 1.363.967.094.068.01.115.253 2.924.022.26-.261.012h0-.024l-.068.004c-.058.003-.14.007-.232.014a9.094 9.094 0 00-.605.057 5.558 5.558 0 00-.63.142 11.823 11.823 0 00-.336.098l-.02.006-.005.002h-.002 0l-.243.077zm0 0l.243-.076-.243.076z",
      fill: "#2E42A5",
      stroke: "#fff",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HR_svg__d",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 11,
      y: 2,
      width: 5,
      height: 6
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.445 7.604l-.072-.244-.867-2.944-.04-.14.1-.104 1.239-1.284.149-.155.175.125 1.363.967.094.068.01.115.253 2.924.022.26-.261.012h0-.024l-.068.004c-.058.003-.14.007-.232.014a9.094 9.094 0 00-.605.057 5.558 5.558 0 00-.63.142 11.823 11.823 0 00-.336.098l-.02.006-.005.002h-.002 0l-.243.077zm0 0l.243-.076-.243.076z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 0.5
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HR_svg__d)", fill: "#C51918" }, /* @__PURE__ */ e.createElement("path", { d: "M12.436 6.638l-.25-.59c.538-.236 1.446-.38 2.403-.437l.037.642c-.89.052-1.73.184-2.19.385zM12.014 5.21l-.25-.59c.538-.235 1.694-.426 2.65-.482l.037.641c-.889.053-1.977.23-2.437.431z" })), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.97 7.606l.067-.252.796-2.948.036-.133-.093-.101-1.167-1.279-.15-.163-.18.128-1.362.967-.095.068-.01.115-.252 2.924-.022.26.26.012H16.824l.067.004c.058.003.14.007.233.014.188.012.42.03.604.057.177.024.422.085.631.142a11.823 11.823 0 01.336.098l.02.006.005.002h.001l.25.08zm0 0l-.25-.078.25.078z",
      fill: "#2E42A5",
      stroke: "#fff",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HR_svg__e",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 16,
      y: 2,
      width: 5,
      height: 6
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18.97 7.606l.067-.252.796-2.948.036-.133-.093-.101-1.167-1.279-.15-.163-.18.128-1.362.967-.095.068-.01.115-.252 2.924-.022.26.26.012H16.824l.067.004c.058.003.14.007.233.014.188.012.42.03.604.057.177.024.422.085.631.142a11.823 11.823 0 01.336.098l.02.006.005.002h.001l.25.08zm0 0l-.25-.078.25.078z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 0.5
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HR_svg__e)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.397 6.466s.294-.164.337-.44c.042-.275.497-.615.27-.575-.228.04-.098.072-.427 0-.33-.072-.756-.12-.756-.322s.212-.363.04-.363c-.174 0-.543-.191-.47-.045.075.147-.17-.019-.047.285.122.304-.026.61.048.69.074.081-.049.477-.049.477s.046.146.124-.074c.079-.22.25-.374.165-.187-.086.187-.196.632-.098.554a.696.696 0 00.195-.367c0-.072.247-.358.247-.142s-.232.386-.116.386.181.045.255-.17c.073-.216.25-.36.323-.216.073.142.057.135-.04.322-.098.187 0 .187 0 .187z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.707 4.866l-.11-.183c.197-.121.377-.153.535-.086.072.03.127.066.268.165l.019.013c.147.103.225.146.273.146v.214c-.11 0-.205-.052-.393-.184l-.019-.013a1.313 1.313 0 00-.23-.143c-.087-.038-.2-.017-.343.071zm-.347 1.397c.063 0 .113-.05.113-.111a.112.112 0 00-.113-.111.112.112 0 00-.112.11c0 .062.05.112.112.112zm.324.103c0 .061-.05.111-.113.111a.112.112 0 01-.112-.11c0-.062.05-.112.113-.112.062 0 .112.05.112.111zm.266.103c.063 0 .113-.05.113-.11a.112.112 0 00-.113-.112.112.112 0 00-.112.111c0 .062.05.111.112.111zm.465.067c0 .061-.05.111-.113.111a.112.112 0 01-.113-.111c0-.061.05-.111.113-.111.062 0 .113.05.113.11z",
      fill: "#C51918"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.352 8.186l-.108.25-.239-.129h0-.001l-.005-.003-.02-.01a7.545 7.545 0 00-.358-.178 6.985 6.985 0 00-.784-.32 13.03 13.03 0 00-.9-.254l-.056-.013-.014-.003h-.003v-.001h0l-.26-.058.073-.254.846-2.976.035-.122.118-.044 1.659-.62.194-.072.107.177.94 1.548.066.11-.051.12-1.239 2.852z",
      fill: "#56C6F5",
      stroke: "#fff",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HR_svg__f",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 18,
      y: 3,
      width: 5,
      height: 6
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M21.352 8.186l-.108.25-.239-.129h0-.001l-.005-.003-.02-.01a7.545 7.545 0 00-.358-.178 6.985 6.985 0 00-.784-.32 13.03 13.03 0 00-.9-.254l-.056-.013-.014-.003h-.003v-.001h0l-.26-.058.073-.254.846-2.976.035-.122.118-.044 1.659-.62.194-.072.107.177.94 1.548.066.11-.051.12-1.239 2.852z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 0.5
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HR_svg__f)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.128 5.09l-.142.158a.054.054 0 01-.094-.03l-.022-.213-.208-.043a.054.054 0 01-.02-.097l.172-.125-.067-.202a.054.054 0 01.074-.067l.194.088.142-.16a.054.054 0 01.095.032l.021.212.209.043c.046.01.059.07.02.097l-.172.125.066.202a.054.054 0 01-.074.066l-.194-.087z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.996 6.488l.213-.829c.94.249 1.921.567 2.64.875l-.327.79c-.68-.291-1.622-.597-2.526-.836z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.283 5.723l.05-.208c.902.223 1.86.58 2.557.913l-.09.194a14.127 14.127 0 00-2.517-.9zM19.016 6.577l.05-.208c.902.224 1.735.528 2.432.86l-.09.194a12.768 12.768 0 00-2.392-.846z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.424 6.175l.193-.087c.081.19.182.232.35.15.396-.192 1.38.077 1.38.44 0 .142-.082.228-.208.223a.659.659 0 01-.257-.086 3.433 3.433 0 01-.044-.022 1.321 1.321 0 00-.164-.079l.07-.204c.045.016.052.02.188.089l.042.02a.542.542 0 00.173.065c.003 0-.011.015-.011-.006 0-.16-.8-.379-1.08-.243-.277.135-.504.04-.632-.26z",
      fill: "#272727"
    }
  ))))
);
export {
  t as default
};
